import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge8 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権とは？' fontWeight={700} />
                <p>
                    ゴルフ会員権とは、会員制のゴルフ場の利用権（権利）です。そのゴルフ場の利用権を得る事によりビジター（非会員）に比べ割安料金でプレーが可能となる他、会員優先枠での予約も可能となります。またクラブ競技会等への参加資格などなど、多くのメリットを得る事が出来ます。
                    <br />
                    ゴルフ会員権には預託会員制、株主会員制、社団法人制の３種類があります。まずはそれら３種類を説明致します。
                    <br />
                    <br />
                    預託会員制は、会員権を購入する際に会員が一定の金額を預託金としてゴルフ場会社に預け、優先的施設利用権と預託金返還請求権を取得して会員となる制度で、日本のゴルフ場の大半を占めています。会員は施設優先利用権と共に、預託金返還請求権を得る事になります。
                    <br />
                    <br />
                    株主会員制は、会員が入会時に株主として一定の金額を出資することで、ゴルフ場経営会社の株主となり施設利用権を取得する制度です。クラブが解散となった時には持株比率に応じて、クラブ残余財産を請求出来る権利があります。株主としての権利行使や売買に関しては定款に定められた規定に従います。資産と権利が明確であるため評価が高いゴルフ会員権です。
                    <br />
                    <br />
                    社団法人制は、ゴルフと体育振興を目的として設立された公益法人で名門コースに多く見られます。この公益法人の構成員を社員といいますが、会員の権利は「社員たる地位」から導かれるものではなく、社団法人と会員間の契約に根拠を有しています。公益法人のため、会員としての地位は一代限りあるいは直系親族のみにしか継承を認めないケースが多く、例外的に譲渡可能な会員権もありますがごく僅かです。また、運営に必要な費用は会員が平等に負担します。
                    <br />
                    <br />
                    ところでゴルフ会員権にかかる費用はどのようなものがあるでしょうか。ゴルフ会員権代金の他にかかる費用をご紹介致します。
                </p>

                <Heading3 title='名義書換料' />
                <p>
                    名義書換手続きにかかる費用です。ゴルフ場が旧名義人から新名義人への名義書換手数料として新入会者（新名義人）から徴収しています。ゴルフ会員権を売却する方（旧名義人）が支払う必要はありません。
                    <br />
                    名義書換料は年会費と共にゴルフ場の大きな収入源となっており、入会預託金などとは異なり返還は受けられません。
                </p>

                <Heading3 title='年会費' />
                <p>
                    ゴルフ会員権所有者（クラブのメンバー）は、ゴルフ場の利用権を行使するために、年会費を負担しなければなりません。通常は年会費制で、口座振替または銀行・郵便局等で払うのが一般的です。年会費の金額は名義書換料と同様、ゴルフ場ごとに決められています。また正会員、平日会員など種別によって金額が変わります。
                </p>

                <Heading3 title='取扱手数料・売買手数料' />
                <p>ゴルフ会員権業者を通じて売買した際、その会員権業者に対して支払う手数料です。</p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権のメリット' fontWeight={700} />
                <p>
                    ゴルフ会員権は必要か？とお考えになるのには皆様それぞれの理由があるかと思いますがゴルフをより楽しむためにはゴルフ会員権を所有しメンバーになることが重要です。
                    <br />
                    ゴルフ会員権の購入メリットとしては、メンバーになれば予約が優先される、ゴルフ場によっては予約なしで行けるなど、「自分の好きな時にゴルフが出来る」という事が一般的ではないでしょうか。
                    <br />
                    また一人でゴルフ場に行ってもプロフィールが分かるメンバー同士でゴルフが出来るという事は会員ならではのメリットです。
                    <br />
                    <br />
                    アスリート（競技）志向の方は、公式ハンディキャップが取得出来る事はもちろん、ゴルフ場主催の月例競技会などの倶楽部競技に参加してメンバーと技量を競うことが出来ます。またホームコースを数多く反復してプレーする事により上達も早まります。
                    <br />
                    <br />
                    多くの仲間が出来る事もメンバーライフの大きな楽しみのひとつです。メンバーは全員ゴルフ場の入会審査で承認された方々なので、いわば仕事抜きで共通の趣味を持った仲間同士です。どこのゴルフ場も多くのメンバーがいらっしゃいますので、高い確率で生涯の友とも呼べる仲間が出来るはずです。
                    <br />
                    <br />
                    先にも述べましたが、プレー料金に関してはビジターと比べて格段に安くプレー出来るので、ゴルフのプレー回数も増え、ゴルフというスポーツが一層身近なものになります。
                    <br />
                    <br />
                    そしてメンバーになれば友人や知人をゲストとして自分のホームコースに招待出来る事はもちろん、多くのクラブでは同伴ビジターも割安でプレー出来ますし、提携コースの優待利用も出来ます。
                    <br />
                    また会員同士の親睦を深めるための食事会やコンサートなど、独自の会員向けサービスを展開しているゴルフ場も数多くあります。
                    <br />
                    時にはラウンドしなくても練習場のみの利用や、ドライブがてらにレストランだけを利用するなど、ゴルフ会員権を取得すれば一流ゴルフ場をまるで自分の庭のように利用する事が可能となります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権のデメリット' fontWeight={700} />
                <p>
                    ここでゴルフ会員権を購入するデメリットについて考えたいと思います。
                    <br />
                    <br />
                    せっかくゴルフ会員権が必要か否かを検討した後に購入して会員になっても、利用せずにいては全く意味がありません。入会の際に名義書換料を支払っているので、使わずにいてはそれが無駄になってしまいます。
                    <br />
                    また、年会費の請求があるので、ゴルフ会員権を維持するにはコストもかかります。会員になればビジターよりも安くプレーが出来るのですから、少なくても年会費分の元が取れるように回数を重ねる事が大切です。
                    <br />
                    <br />
                    では、使いやすい（プレー回数を重ねやすい）クラブはどんな所でしょう。まずは交通の利便性が良いところです。遠方のコースはどうしても足が遠のきます。
                    <br />
                    また、往復の交通費も無視できません。それからコースにお金をかけないクラブ、つまりコースメンテナンスの悪いところも要注意です。そうしたところは結局足が遠のくことに繋がりやすいと言えるでしょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    ゴルフ会員権はゴルフという生涯スポーツをより身近な存在にさせるための必須のツールといえるでしょう。またゴルフ場でプレーを繰り返していくと、どうしても理想の高いゴルフを実現させたくなるものですが、理想は人それぞれです。何処が自分に合ったクラブなのか、また、何処が自分にとってメリットが多いクラブなのか。最適なクラブライフを見つけるお手伝いをさせて頂きます。
                    <br />
                    <br />
                    ゴルフ会員権が必要か不要か迷った際は、是非当社にお問合せください。
                    <br />
                    私たちは常にお客様目線でアドバイス出来るよう体制を整えてお待ちしております。
                </p>
            </section>
        </div>
    );
};

export default Knowledge8;
